<script setup lang="ts">

const model = defineModel();

defineProps([
  'label',
  'required',
  'inputmode',
  'disabled',
  'error',
  'errorMessages',
]);

</script>
<template>
  <v-text-field
    v-model="model"
    :label="label"
    :inputmode="inputmode"
    :required="required"
    :disabled="disabled"
    :error="error"
    :error-messages="errorMessages"
    variant="outlined"
    density="compact"
    hide-details="auto"
    v-uppercase
  />
</template>

<style scoped>

</style>
